module.exports = __webpack_public_path__ + "img/checkbox.d19e621c.svg";